import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useContext } from "react";
import { DashboardContext } from "../../../../DashboardContext/DashboardContextProvider";

const submitForm = async (clientId, projectId, slide12) => {
  try {
    const res = await axios.patch(
      `/api/submit-form/${clientId}/${projectId}/`,
      {
        submitter: slide12.submitterName,
        submitterPhone: slide12.submitterPhone,
        submitterEmail: slide12.submitterEmail,
        submitterTitle: slide12.submitterTitle,
      },
      { withCredentials: true },
    );

    console.log("SUBMIT FORM RESPONSE: ", res.data);
    return res.data;
  } catch (error) {
    console.log("SUBMIT FORM ERROR: ", error);
  }
};

export default function useSubmitForm(
  clientId,
  projectId,
  isReady,
  setIsReady,
  enqueueSnackbar,
  setIsLoading,
  slide12,
) {
  const { queryClient, isAdmin, navigate } = useContext(DashboardContext);
  // console.log("SLIDE 10: ", slide10);

  const submit = useMutation({
    mutationFn: () => {
      if (isReady === false) {
        return;
      } else {
        return submitForm(clientId, projectId, slide12);
      }
    },
    onError: (error) => {
      enqueueSnackbar("Error submitting form. Please try again.", {
        variant: "error",
      });
      setIsReady(false);
    },
    onSuccess: (data) => {
      enqueueSnackbar("Form submitted successfully!", {
        variant: "success",
        autoHideDuration: 3000,
      });
      if (isAdmin) {
        queryClient.invalidateQueries(["adminRows"]);
        navigate(`/dashboard/admin`, { replace: true });
      } else {
        queryClient.invalidateQueries(["clientRows", clientId, projectId]);
        navigate(`/dashboard/client/${clientId}`, {
          replace: true,
        });
      }
    },
    onSettled: (data) => {
      setIsLoading(false);
    },
  });

  return submit;
}
